import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

export default class SupplierInvoicesPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		const { match } = this.props;
		const path = nullSafeGetOrElse('path', match, '/supplier/invoices');
		return (
			<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_INVOICES} isPage>
				<div>
					<Route
						path={`${path}`}
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: `${path}/overview`,
								}}
							/>
						)}
					/>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</div>
			</AccessPermissionChecker>
		);
	}
}
